// extracted by mini-css-extract-plugin
module.exports = {"content":"_2xmBA","full":"sW6me","doubleSlice":"_30mNa","slice":"_2YevN","image":"xmPG-","video":"ig6SB","btn":"_3MeNt","imageSmall":"dfzbA"};